import React from 'react'

const IconDefaultCheckboxChecked = () => {
  return (
    <svg viewBox='0 0 24 24' fill='none'>
      <rect x='3' y='3' width='18' height='18' rx='2' stroke='currentColor' strokeWidth='2' />
      <path
        d='M7 12L10.5 15.5L17 9'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default IconDefaultCheckboxChecked
